import { h, Component } from 'preact';
import { sortedSecurityList } from '@os/cloudquote';
import { shallowEqual } from '../../lib/util';
import StockInfoTable from '../stock-info-table';
import style from './style';

export default class StockList extends Component {

	fetchSortedSecurityList = (query) => {
		sortedSecurityList(query)
			.then((data) => {
				this.setState({ data });
			});
	}

	componentWillMount() {
		this.fetchSortedSecurityList(this.props.query);
	}

	componentWillReceiveProps(nextProps) {
		if (!shallowEqual(nextProps.query, this.props.query)) {
			this.fetchSortedSecurityList(nextProps.query);
		}
	}

	render({ query, ...props }, { data }) {
		if (!data) return <div />;

		return (
			<div class={style['stock-list']}>
				<StockInfoTable data={data} abbrv {...props} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-list/index.js